var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAutocomplete',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"items":_vm.questionTypes,"item-text":"title","item-value":"value","hide-details":"","clearable":_vm.isClearable,"returnObject":false},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }